import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { CountrySelector } from "./CountrySelector";

const cols = [
  { title: "Products", links: [["/products/bundle", "The Bundle"], ["/products/ebook", "The eBook"], ["/products/workbook", "The Workbook"]] },
  { title: "Company", links: [["/about", "About Dilara"], ["/support", "FAQ"], ["/blog", "Blog"], ["/support#contact", "Contact"], ["/review", "Leave a review"]] },
  { title: "Legal", links: [["/support#refund", "Refund policy"], ["/support#privacy", "Privacy"], ["/support#terms", "Terms"]] },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-line bg-[#050505]">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-20 md:grid-cols-12 md:px-12">
      <div className="md:col-span-5">
        <LogoMark className="h-10 w-10 text-white" />
        <p className="font-display mt-6 max-w-sm text-2xl leading-snug text-white">
          Spot the shift. <span className="font-serif-i text-zinc-400">Move first.</span>
        </p>
        <p className="mt-4 text-sm text-zinc-400">Every order is covered by our 7-day money-back guarantee.</p>
        <CountrySelector />
      </div>
      {cols.map((c) => (
        <div key={c.title} className="md:col-span-2">
          <p className="eyebrow mb-5">{c.title}</p>
          <ul className="space-y-3">
            {c.links.map(([to, label]) => (
              <li key={to}><Link to={to} className="link-u text-sm text-zinc-300 hover:text-white">{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="mx-auto flex max-w-7xl flex-col gap-2 border-t border-line px-6 py-6 text-xs text-zinc-400 md:flex-row md:justify-between md:px-12">
      <span>&copy; {new Date().getFullYear()} First Mover OS. All rights reserved.</span>
      <span>Secure checkout via Shopify &middot; Shop Pay &middot; Klarna &middot; PayPal</span>
    </div>
  </footer>
);
